module.exports = __webpack_public_path__ + "static/img/traffic-img01-01.715f2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resolution/traffic-img01-01.png
// module id = 3XUO
// module chunks = 7